import { IonRow, IonCol, IonImg } from "@ionic/react";
import { useState, useEffect } from "react";

export const SpinningLogo = (props) => {
  const { className, logos, onLoaded } = props;
  const [frontLoaded, setFrontLoaded] = useState(false);
  const [backLoaded, setBackLoaded] = useState(false);

  useEffect(() => {
    if (frontLoaded && backLoaded && onLoaded) {
      onLoaded();
    }
  }, [frontLoaded, backLoaded, onLoaded]);

  return (
    <IonRow className="spinning-logo-row">
      <IonCol size="auto" className={className}>
        <IonImg
          className="logo-front"
          src={logos?.logoFront}
          alt="logo-hb"
          draggable="false"
          loading="eager"
          decoding="async"
          fetchpriority="high"
          onIonImgDidLoad={() => setFrontLoaded(true)}
        />
        <div className="logo-back-container">
          <IonImg
            src={logos?.logoBack}
            className="logo-back"
            alt="mandala"
            draggable="false"
            loading="eager"
            decoding="async"
            fetchpriority="high"
            onIonImgDidLoad={() => setBackLoaded(true)}
          />
        </div>
      </IonCol>
    </IonRow>
  );
};
